import React from 'react';
import { MdOutlineEmail } from 'react-icons/md';

import { RiLinkedinBoxFill } from 'react-icons/ri';
import './header.css';
import { useTranslation } from '../../contexts/TranslationContext';

const HeaderSocials = () => {
  const { t } = useTranslation();
  return (
    <div className="header__socials">
      {/* Lien pour envoyer un email */}
      <a
        className="socials"
        href="mailto:tanguybruschi.son@gmail.com?subject=Mail"
        target="_blank"
        rel="noreferrer"
        aria-label={t('socials.email')}
      >
        <MdOutlineEmail />
      </a>

      {/* Linkedin*/}
      { 
      <a
        className="socials"
        href="https://www.linkedin.com/in/tanguy-bruschi-a5a060380/"
        target="_blank"
        rel="noreferrer"
        aria-label="Send me a message on Linkedin !"
      >
        <RiLinkedinBoxFill />
      </a> 
      }
    </div>
  );
};

export default HeaderSocials;
